import { createContext } from "react";

import type { AlertModalMessageProps } from "./types";

export type Context = {
  state: AlertModalMessageProps;
  show: (
    args: AlertModalMessageProps & {
      onClose?: () => any;
    }
  ) => any;
  hide: () => any;
};

export const defaultState: AlertModalMessageProps = {
  title: null,
  message: null,
  buttons: undefined,
};

const defaultValue = {
  state: defaultState,
  show: ({ }) => { },
  hide: () => { },
};

export const AlertModalContext = createContext(defaultValue as Context);

export default AlertModalContext;
